require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 341
// module chunks = 0